<!-- =========================================================================================
    File Name: Search.vue
    Description: Search Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="search-page">
    <vx-tour :steps="steps" v-if="showTour" />
    <div class="search-page__search-bar flex items-center"></div>
    <br />
    
    <vs-collapse
      style="background: rgb(255, 255, 255)"
      accordion
      class="js-search"
      v-if="false"
    >
      <vs-collapse-item aria-expanded="true">
        <div slot="header">{{ $t('BasicSearch') }}</div>
      </vs-collapse-item>
    </vs-collapse>

    <!-- SEARCH RESULTS -->
    <div class="vx-row mt-4 md:flex-row flex-col-reverse" style="margin: 0px">
      <div class="vx-col md:w-3/4 w-full search-results-cards">
        <vx-card class="overflow-hidden mb-3">
          <vs-input :placeholder="$t('SearchPlaceholder')"
                    v-model="searchQuery"
                    class="w-full input-rounded-full no-icon-border js-basic-search-input code-search-input"
                    icon="icon-search"
                    icon-pack="feather"
                    @keyup.enter="reSearch(searchQuery, null, 1, null)" />
          <div class="search-meta flex flex-wrap justify-between mt-2"
               v-if="totalResults != null">
            <span class="mb-1">{{ totalResults }} {{ $t('Results') }}</span>
          </div>
        </vx-card>

        <vx-card class="search-page__search-results lg:p-2">
          <div class="vx-row search-Page__search-result"
            v-for="(result, index) in searchResults"
            :key="index"
               :class="{ 'mt-8': index }">
            <div class="vx-col"
              :class="
                result.firstImage || result.resultImg || result.resultVideo
                  ? 'lg:w-4/5 md:w-3/4'
                  : 'w-full'
              ">
              <a :href="result.linkUrl"
                class="inline-block text-2xl"
                target="_blank"
                 rel="nofollow">{{ result.title | truncate(50) | tailing("...") }}</a><br />
              <a :href="result.resultUrl"
                class="inline-block text-success mb-1 long-label"
                target="_blank"
                 rel="nofollow">{{ result.resultTitle }} in {{ result.project }}</a>
              <br />
              
              <!-- Intent Pills -->
              <div v-if="result.intents && result.intents.length > 0" class="mb-2">
                <span v-for="intent in result.intents" :key="`${intent.category}-${intent.value}`"
                      class="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full mr-1 mb-1">
                  {{ intent.value }}
                </span>
              </div>

              <!-- META DATA ROW -->
              <div class="flex flex-wrap items-center search-page__search-result-meta my-1"
                   v-if="result.metaData">
                <!-- RATINGS -->
                <div class="flex items-center search-page__search-result-ratings mr-3"
                     v-if="result.metaData.ratings">
                  <img src="@/assets/images/raty/star-on-2.png"
                    alt="rating"
                    v-for="i in Math.floor(result.metaData.ratings)"
                    :key="i"
                       class="mb-1" />
                  <img src="@/assets/images/raty/star-half-2.png"
                    alt="rating"
                    v-if="result.metaData.ratings % 1"
                       class="mb-1" />
                </div>
                <div>
                  <span class="mr-2"
                    v-for="(info, infoIndex) in result.metaData.info"
                        :key="infoIndex">
                    {{ info }}
                    <span v-if="infoIndex < result.metaData.info.length - 1">|</span>
                  </span>
                </div>
              </div>
              <!-- RESULT DESC -->
              <span v-if="result.time">{{ result.time | date(true) }} -</span>
              <!-- <div data-raw="true" style="">
                <pre>{{ result.rawDocument }}</pre>
              </div> -->
                            <div v-if="result.description" class="mb-3">
                <div v-html="
                     result.highlights && result.highlights.length>
                  0
                  ? result.highlights
                  : result.description
                  "
                  >
                </div>
              </div>
              <!-- SITE LINKS -->
              <div class="vx-row mt-6" v-if="result.sitelinks">
                <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-5"
                  v-for="(sitelink, index) in result.sitelinks"
                     :key="index">
                  <a :href="sitelink.url"
                    class="inline-block mb-1"
                    target="_blank"
                     rel="nofollow">{{ sitelink.title | truncate(30) | tailing("...") }}</a>
                  <br />
                  <p>
                    {{ sitelink.description | truncate(1500) | tailing("...") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div v-if="(!searchResults || searchResults.length == 0) && !IsSearching">
            <div class="vx-col flex items-center justify-center flex-col sm:w-1/3 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
              <img src="../../assets/images/pages/404.png"
                alt="graphic-404"
                   class="mx-auto mb-4 max-w-full" />
              <h1 v-if="searchQuery != null && searchQuery.length > 0"
                  class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color">
                <strong style="font-weight: 800">{{ searchQuery }}</strong>
                {{ $t('FoundNothing') }}
              </h1>
              <h1 v-else>{{ $t('NoResults') }}</h1>
              <p class="sm:mx-0 mx-4 mb-4 sm:mb-16 d-theme-heading-color">
                {{ $t('SearchReturnedNoResults') }}
                <br />
                <strong>{{ $t('KeepTrying') }}</strong>
              </p>
            </div>
          </div>
          <div v-if="IsSearching">
            <div class="vx-col flex items-center justify-center flex-col sm:w-1/3 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
              <img src="../../assets/images/pages/404.png"
                alt="graphic-404"
                   class="mx-auto mb-4 max-w-full" />
              <h1 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color">
                {{ $t('WorkingSearch') }}
              </h1>
              <p class="sm:mx-0 mx-4 mb-4 sm:mb-16 d-theme-heading-color">
                <br />
                <strong>{{ $t('ResultsComingShortly') }}</strong>
              </p>
            </div>
          </div>
        </vx-card>
        <vs-pagination :total="totalPages"
          v-model="currentPage"
                       class="mt-base"></vs-pagination>
      </div>
      <div class="v-col md:w-1/5 ml-3 w-full">
        <vx-card>
          <div>
            <!-- Intent Filters -->
            <div class="mb-3 mt-3">
              <div class="mb-2">
                <strong>{{ $t('IntentFilters') }}</strong>
              </div>
              <div class="flex justify-end mb-2">
                <vs-button size="small" color="primary" @click="showAllFilters" class="mr-1">{{ $t('ShowAll') }}</vs-button>
                <vs-button size="small" color="danger" @click="clearIntentFilters">{{ $t('ClearAll') }}</vs-button>
              </div>
              <div v-for="(values, key) in intentFilters" :key="key" class="mt-2">
                <label class="block text-sm font-medium mb-1">{{ key }}:</label>
                <vs-input v-model="itemFilters[`intent_${key}`]"
                          :placeholder="`${$t('Filter')} ${key.toLowerCase()}`"
                          class="mb-1" />
                <div v-for="(value, index) in values" :key="index" class="mb-1">
                  <vs-checkbox v-if="!itemFilters[`intent_${key}`] ||
                    itemFilters[`intent_${key}`].length === 0 ||
                    value.toLowerCase().includes(itemFilters[`intent_${key}`].toLowerCase())"
                               v-model="selectedIntents[key]"
                               :vs-value="value">
                    <span :title="value">{{ value | truncate(20, true) }}</span>
                  </vs-checkbox>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import SearchService from "@/search/searchService.js";

const VxTour = () => import("@/components/VxTour.vue");

export default {
  data() {
    return {
      IsSearching: false,
      searchQuery: "",
      currentPage: 1,
      itemsPerPage: 20,
      totalPages: 0,
      searchResults: [],
      showTour: false,
      totalResults: null,
      steps: [
        {
          target: ".code-search-input",
          content:
            "You can search for code here. Just type anything and hit enter.",
        },
        {
          target: ".copy-link-btn",
          content: "To copy link for the search, use this button.",
        },
      ],

      intentFilters: {},
      selectedIntents: {},
      itemFilters: {},
      allIntentFilters: {}, // Store all available filters

    };
  },

  mounted() {
    var instance = this;

    var qs = this.getQS();
    if (qs && qs.q && qs.q.length > 0) {
      instance.$set(instance, "searchQuery", qs.q);
      instance.reSearch();
    } else if (qs && qs.skill) {
      var skillId = qs.skill * 1;
      if (!isNaN(skillId)) {
        var project = "";
        if (qs.project) {
          project = decodeURIComponent(qs.project);
        }

        instance.$set(instance, "skillId", qs.skill);
        instance.$set(instance, "projectFilter", project);
        instance.reSearch(null, null, this.currentPage);
      }
    }

    // Load available intent filter values from existing documents
    instance.loadExistingIntents();
  },
  computed: {},
  watch: {
    currentPage: function (newVal) {
      this.reSearch(this.searchQuery, newVal);
    },
    selectedIntents: {
      handler() {
        this.reSearch(this.searchQuery, null, this.currentPage);
      },
      deep: true,
    },
  },
  methods: {
    getQS() {
      // TODO: make sure we move this to utility method or in the router.
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      var qObj = {};
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        qObj[pair[0]] = pair[1];
      }
      return qObj;
    },
    loadExistingIntents() {
      const instance = this;
      SearchService.getExistingIntents().then(function (result) {
        if (result && result.data) {
          // Store all available filters
          instance.allIntentFilters = { ...result.data };
          
          Object.keys(result.data).forEach(key => {
            instance.$set(instance.intentFilters, key, result.data[key]);
            // Initialize selected intents for this category
            instance.$set(instance.selectedIntents, key, []);
            // Initialize item filters for this category
            instance.$set(instance.itemFilters, `intent_${key}`, null);
          });
        }
      }).catch(function (error) {
        console.error("Error loading existing intents:", error);
        // Fallback to empty state
        instance.intentFilters = {};
        instance.selectedIntents = {};
        instance.itemFilters = {};
        instance.allIntentFilters = {};
      });
    },
    clearIntentFilters() {
      Object.keys(this.selectedIntents).forEach(key => {
        this.$set(this.selectedIntents, key, []);
      });
      this.reSearch(this.searchQuery, null, this.currentPage);
    },

    showAllFilters() {
      // Restore all available filters
      Object.keys(this.allIntentFilters).forEach(category => {
        this.$set(this.intentFilters, category, this.allIntentFilters[category]);
      });
    },

    extractIntentsFromItem(item) {
      const intents = [];
      
      Object.keys(item).forEach(key => {
        if (key.startsWith('Additional_')) {
          const intentCategory = key.substring('Additional_'.length);
          const intentValue = item[key];
          
          if (intentValue && intentValue.trim()) {
            try {
              const parsedValue = JSON.parse(intentValue);
              if (Array.isArray(parsedValue)) {
                parsedValue.forEach(val => {
                  if (val && val.toString().trim()) {
                    intents.push({
                      category: intentCategory,
                      value: val.toString().trim()
                    });
                  }
                });
              } else {
                intents.push({
                  category: intentCategory,
                  value: intentValue.trim()
                });
              }
            } catch (e) {
              intents.push({
                category: intentCategory,
                value: intentValue.trim()
              });
            }
          }
        }
      });
      
      return intents;
    },

    createExcerpt(text, searchQuery, maxLength = 200) {
      if (!text || !searchQuery) {
        return text ? text.substring(0, maxLength) + (text.length > maxLength ? '...' : '') : '';
      }

      // Clean the search query and split into words
      const searchTerms = searchQuery.toLowerCase().split(/\s+/).filter(term => term.length > 2);
      
      if (searchTerms.length === 0) {
        return text.substring(0, maxLength) + (text.length > maxLength ? '...' : '');
      }

      // Find the best position to start the excerpt (where most search terms appear)
      let bestPosition = 0;
      let maxMatches = 0;

      for (let i = 0; i < text.length - 50; i++) {
        const window = text.substring(i, i + 100).toLowerCase();
        let matches = 0;
        
        searchTerms.forEach(term => {
          if (window.includes(term)) {
            matches++;
          }
        });

        if (matches > maxMatches) {
          maxMatches = matches;
          bestPosition = i;
        }
      }

      // Create excerpt starting from the best position
      let excerpt = text.substring(bestPosition, bestPosition + maxLength);
      
      // Add ellipsis if we're not at the beginning or end
      if (bestPosition > 0) {
        excerpt = '...' + excerpt;
      }
      if (bestPosition + maxLength < text.length) {
        excerpt = excerpt + '...';
      }

      // Highlight search terms
      searchTerms.forEach(term => {
        const regex = new RegExp(`(${term})`, 'gi');
        excerpt = excerpt.replace(regex, '<mark class="search-highlight">$1</mark>');
      });

      return excerpt;
    },

    stripHtml(html) {
      if (!html) return '';
      // Create a temporary div to parse HTML and extract text
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;

      tempDiv.querySelectorAll('p').forEach(p => {
        p.textContent += " ";
      });

      return tempDiv.textContent || tempDiv.innerText || '';
    },

    stripMetadata(textContent) {
      var str = this.removeJsonObjects(textContent)
      return str
    },

   removeJsonObjects(str) {
    let result = '';
    let lastIndex = 0;
    let braceLevel = 0;
    let inString = false;

    for (let i = 0; i < str.length; i++) {
      const char = str[i];

      if (braceLevel > 0) {
        if (inString) {
          if (char === '"' && str[i - 1] !== '\\') {
            inString = false;
          }
        } else {
          if (char === '"') {
            inString = true;
          } else if (char === '{') {
            braceLevel++;
          } else if (char === '}') {
            braceLevel--;
            if (braceLevel === 0) {
              lastIndex = i + 1;
            }
          }
        }
      } else {
        if (char === '{') {
          result += str.substring(lastIndex, i);
          braceLevel = 1;
          inString = false;
        }
      }
    }
    if (lastIndex < str.length) {
      result += str.substring(lastIndex);
    }

    return result;
  },

    extractIntentsFromResults(results) {
      const availableIntents = {};
      
      results.forEach(item => {
        // Look for Additional_* fields in the raw data
        Object.keys(item).forEach(key => {
          if (key.startsWith('Additional_')) {
            const intentCategory = key.substring('Additional_'.length);
            const intentValue = item[key];
            
            if (intentValue && intentValue.trim()) {
              if (!availableIntents[intentCategory]) {
                availableIntents[intentCategory] = new Set();
              }
              
              // Try to parse as JSON array first
              try {
                const parsedValue = JSON.parse(intentValue);
                if (Array.isArray(parsedValue)) {
                  // It's a JSON array, add each value
                  parsedValue.forEach(val => {
                    if (val && val.toString().trim()) {
                      availableIntents[intentCategory].add(val.toString().trim());
                    }
                  });
                } else {
                  // Single value
                  availableIntents[intentCategory].add(intentValue.trim());
                }
              } catch (e) {
                // Not JSON, treat as plain string
                availableIntents[intentCategory].add(intentValue.trim());
              }
            }
          }
        });
      });
      
      // Convert Sets to Arrays and sort
      const result = {};
      Object.keys(availableIntents).forEach(category => {
        result[category] = Array.from(availableIntents[category]).sort();
      });
      
      return result;
    },

    updateAvailableFilters(availableIntents) {
      // Update the intent filters to show only available values
      Object.keys(this.intentFilters).forEach(category => {
        if (availableIntents[category]) {
          // Show only the values that are available in current results
          this.$set(this.intentFilters, category, availableIntents[category]);
        } else {
          // If no values for this category in results, show empty array
          this.$set(this.intentFilters, category, []);
        }
      });
    },


    reSearch(phrase, query, page) {
      var instance = this;

      this.$set(this, "IsSearching", true);
      this.$set(this, "searchResults", null);

      if (page && page > 0) {
        instance.$set(instance, "currentPage", page);
      }

      // Always use SearchWithIntent endpoint
      const intentParams = {};
      Object.keys(instance.selectedIntents).forEach(key => {
        if (instance.selectedIntents[key] && instance.selectedIntents[key].length > 0) {
          intentParams[key] = instance.selectedIntents[key];
        }
      });

      SearchService.searchWithIntent(
        instance.searchQuery || "",
        intentParams,
        "",
        false, // shortResults = false to get all raw text
          instance.itemsPerPage
        ).then(function (result) {
          instance.$set(instance, "IsSearching", false);
        instance.showIntentResults(instance, result);
      }).catch(function (error) {
        console.error("Search error:", error);
        instance.$set(instance, "IsSearching", false);
      });
    },


    showIntentResults(instance, result) {
      try {
        // Handle both string and object responses
        const parsedResult = typeof result === 'string' ? JSON.parse(result) : result;
        
        // Debug logging to see the actual structure
        console.log("Intent search result structure:", parsedResult);
        console.log("Type of parsedResult:", typeof parsedResult);
        console.log("Is Array:", Array.isArray(parsedResult));
        
        // Handle different response structures
        let results = [];
        if (Array.isArray(parsedResult)) {
          results = parsedResult;
        } else if (parsedResult && typeof parsedResult === 'object') {
          // If it's an object, check if it has a data property or similar
          if (parsedResult.data && Array.isArray(parsedResult.data)) {
            results = parsedResult.data;
          } else if (parsedResult.results && Array.isArray(parsedResult.results)) {
            results = parsedResult.results;
          } else {
            // If it's a single object, wrap it in an array
            results = [parsedResult];
          }
        }
        
        instance.$set(instance, "totalResults", results.length);
        instance.$set(instance, "totalPages", Math.ceil(results.length / instance.itemsPerPage));

        if (!results || results.length === 0) {
        instance.$set(instance, "searchResults", null);
        return;
      }

        const resultsNew = results.map(item => {
          const fullDescription = item.Description || "";
          const descriptionExcerpt = this.createExcerpt(fullDescription, instance.searchQuery, 200);
          
          // Process RawContent if available
          const rawContent = item.RawContent || "";
          const rawContentText = this.stripHtml(rawContent);
          const rawContentTextNoMetadata = this.stripMetadata(rawContentText)
          const rawContentExcerpt = this.createExcerpt(rawContentTextNoMetadata, instance.searchQuery, 300);
          
          // Combine excerpts, preferring RawContent if it has more relevant content
          const finalExcerpt = rawContentExcerpt.length > descriptionExcerpt.length ? 
            rawContentExcerpt : descriptionExcerpt;
          
          // Extract intents for this item
          const intents = this.extractIntentsFromItem(item);
          
          return {
            title: item.Name || "Untitled",
            linkUrl: `/pages/pdf-view?oid=${item.Id}`,
            resultUrl: `/pages/pdf-view?oid=${item.Id}`,
            time: "",
            highlights: finalExcerpt,
            description: fullDescription,
            rawContent: rawContentText,
            intents: intents,
            itemType: "Onboarding",
            resultTitle: item.Name || "Untitled",
            project: "General",
            data: item,
            language: "Documentation",
            changes: 1,
            firstImage: item.FirstImage || "",
            uid: item.UID || "",
            rawDocument: JSON.stringify(item, null, 3),
          };
        });

              instance.$set(instance, "searchResults", resultsNew);
        
        // Update available filters based on current results
        const availableIntents = this.extractIntentsFromResults(results);
        this.updateAvailableFilters(availableIntents);
        
      } catch (error) {
        console.error("Error parsing intent search results:", error);
        console.error("Raw result:", result);
        instance.$set(instance, "searchResults", null);
        instance.$set(instance, "totalResults", 0);
        instance.$set(instance, "totalPages", 0);
      }
    },


    copyText(evt) {
      const thisIns = this;
      /*eslint no-undef: "error"*/
      var $btn = $(evt.toElement);
      var elmt = $(
        ".js-basic-search-input .vs-inputx",
        $btn.parents(".vs-collapse-item").first()
      );
      var text =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?q=" +
        elmt.val();

      this.$copyText(text).then(
        function () {
          thisIns.$vs.notify({
            title: thisIns.$t('SuccessNotification'),
            text: thisIns.$t('TextCopiedSuccessfully'),
            color: "success",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        },
        function (err) {
          thisIns.$vs.notify({
            title: thisIns.$t('Failed'),
            text: thisIns.$t('ErrorInCopyingText') + " " + err,
            color: "danger",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-alert-circle",
          });
        }
      );
    },
  },
  components: {
    VxTour
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuesax/pages/search.scss";

span.highlight {
  color: white;
}

.long-label {
  max-width: 100%;
  overflow: hidden;
}

.long-body-code {
  padding: 20px;
  background: #efefef;
  max-height: 300px;
  overflow-y: scroll;
}

.description-content {
  padding: 15px;
  background: #f8f9fa;
  border-left: 4px solid #007bff;
  border-radius: 4px;
  max-height: 300px;
  overflow-y: auto;
  line-height: 1.6;
  color: #333;
}

.no-height-limit.vs-collapse-item.open-item .vs-collapse-item--content {
  max-height: initial !important;
}

.search-results-cards {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.router-header {
  display: none !important;
}

// .router-view {
//   padding-top:80px;
// }
</style>
